<main class="marketplace-page" [attr.aria-busy]="isLoading">
  <header class="marketplace-header">
    <p class="marketplace-eyebrow">ANAMETA ONE / KEŞFET</p>
    <h1>Uygulama ve Hizmetler</h1>
    <p class="marketplace-intro">İşinize uygun dijital çözümleri tek yerden keşfedin.</p>

    <form class="marketplace-search" role="search" (ngSubmit)="ApplyFilters()">
      <i class="bi bi-search" aria-hidden="true"></i>
      <label class="marketplace-sr-only" for="marketplace-search-input">Uygulama ara</label>
      <input id="marketplace-search-input" name="marketplaceSearch" type="search"
        [(ngModel)]="searchText" (ngModelChange)="ApplyFilters()"
        placeholder="Uygulama adı, tür veya etiket ara..." autocomplete="off">
      <button type="submit" class="search-submit">Ara</button>
    </form>

    <nav class="category-strip" aria-label="Uygulama kategorileri">
      <button *ngFor="let category of categories" type="button" class="category-item"
        [class.active]="selectedCategory === category.id"
        [attr.aria-pressed]="selectedCategory === category.id"
        (click)="SelectCategory(category.id)">
        <i class="bi" [ngClass]="category.icon" aria-hidden="true"></i>
        <span>{{ category.name }}</span>
      </button>
    </nav>
  </header>

  <div *ngIf="isLoading" class="marketplace-state" role="status" aria-live="polite">
    <span class="marketplace-spinner" aria-hidden="true"></span>
    <h2>Uygulamalar yükleniyor</h2>
    <p>Uygulama ve hizmetler hazırlanıyor, lütfen bekleyin.</p>
  </div>

  <!-- Mevcut hata componenti korunur; yeniden deneme bu panelden yapılır. -->
  <section *ngIf="!isLoading && dashboardErrorMessage" class="marketplace-state error-state" role="alert">
    <i class="bi bi-exclamation-circle" aria-hidden="true"></i>
    <h2>Uygulamalar yüklenemedi</h2>
    <p>{{ dashboardErrorMessage }}</p>
    <button type="button" class="primary-button" (click)="LoadApplications()">Yeniden dene</button>
  </section>

  <ng-container *ngIf="!isLoading && !dashboardErrorMessage">
    <section *ngIf="popularApplications.length" class="popular-panel" aria-labelledby="popular-heading">
      <div class="section-header">
        <div>
          <h2 id="popular-heading">Yüksek Puanlı Uygulamalar</h2>
          <p>Kullanıcı değerlendirmelerine göre öne çıkanlar</p>
        </div>
      </div>
      <div class="popular-grid">
        <ng-container *ngFor="let application of popularApplications; trackBy: TrackApplication">
          <ng-container *ngTemplateOutlet="applicationCard; context: { $implicit: application, featured: true }"></ng-container>
        </ng-container>
      </div>
    </section>

    <section class="applications-panel" aria-labelledby="applications-heading">
      <div class="section-header">
        <h2 id="applications-heading">Tüm Uygulamalar</h2>
      </div>
      <div class="applications-layout">
        <aside class="marketplace-filter" aria-label="Uygulama filtreleri">
          <div class="filter-heading">
            <h3>Filtreler</h3>
            <button type="button" class="text-button" [disabled]="!hasActiveFilters" (click)="ClearFilters()">Temizle</button>
          </div>
          <fieldset class="filter-section">
            <legend>Uygulama Türü</legend>
            <label *ngFor="let filter of categoryFilters; trackBy: TrackFilter" class="filter-row">
              <span class="filter-checkbox-wrap">
                <input type="checkbox" [checked]="selectedTypes.has(filter.id)" (change)="ToggleType(filter.id)">
                <span>{{ filter.name }}</span>
              </span>
              <span class="filter-count">{{ filter.count }}</span>
            </label>
            <p *ngIf="!categoryFilters.length" class="filter-empty">Uygulama türü bulunmuyor.</p>
          </fieldset>
          <fieldset class="filter-section">
            <legend>Etiketler</legend>
            <div class="filter-tags">
              <button *ngFor="let filter of tagFilters; trackBy: TrackFilter" type="button" class="filter-tag"
                [class.active]="selectedTags.has(filter.id)" [attr.aria-pressed]="selectedTags.has(filter.id)"
                (click)="ToggleTag(filter.id)">{{ filter.name }}</button>
            </div>
            <p *ngIf="!tagFilters.length" class="filter-empty">Etiket bulunmuyor.</p>
          </fieldset>
        </aside>

        <div class="applications-content">
          <div class="applications-toolbar">
            <p class="result-count" role="status" aria-live="polite">{{ filteredApplications.length }} uygulama</p>
            <div class="toolbar-actions">
              <label class="marketplace-sr-only" for="marketplace-sort">Uygulamaları sırala</label>
              <select id="marketplace-sort" class="sort-select" [(ngModel)]="sortBy" (ngModelChange)="ApplyFilters()">
                <option value="name">Sıralama: Ada göre (A–Z)</option>
                <option value="name-desc">Sıralama: Ada göre (Z–A)</option>
                <option value="rating">Sıralama: Puana göre</option>
              </select>
              <div class="view-buttons" role="group" aria-label="Liste görünümü">
                <button type="button" class="view-button" [class.active]="viewMode === 'grid'"
                  [attr.aria-pressed]="viewMode === 'grid'" aria-label="Kart görünümü" (click)="viewMode = 'grid'">
                  <i class="bi bi-grid-fill" aria-hidden="true"></i>
                </button>
                <button type="button" class="view-button" [class.active]="viewMode === 'list'"
                  [attr.aria-pressed]="viewMode === 'list'" aria-label="Liste görünümü" (click)="viewMode = 'list'">
                  <i class="bi bi-list-ul" aria-hidden="true"></i>
                </button>
              </div>
            </div>
          </div>

          <div *ngIf="filteredApplications.length; else emptyApplications" class="applications-grid" [class.list-view]="viewMode === 'list'">
            <ng-container *ngFor="let application of pagedApplications; trackBy: TrackApplication">
              <ng-container *ngTemplateOutlet="applicationCard; context: { $implicit: application, featured: false }"></ng-container>
            </ng-container>
          </div>

          <ng-template #emptyApplications>
            <div class="marketplace-state empty-state" role="status">
              <i class="bi bi-search" aria-hidden="true"></i>
              <h3>{{ applications.length ? 'Uygulama bulunamadı' : 'Henüz uygulama bulunmuyor' }}</h3>
              <p>{{ applications.length ? 'Arama veya filtrelerinizi değiştirerek tekrar deneyin.' : 'Uygulamalar yayınlandığında burada listelenecek.' }}</p>
              <button *ngIf="hasActiveFilters" type="button" class="primary-button" (click)="ClearFilters()">Filtreleri temizle</button>
            </div>
          </ng-template>

          <div *ngIf="filteredApplications.length" class="results-footer">
            <p>{{ resultStart }}–{{ resultEnd }} / {{ filteredApplications.length }} uygulama</p>
            <nav *ngIf="totalPages > 1" class="marketplace-pagination" aria-label="Uygulama sayfaları">
              <button type="button" class="pagination-button" aria-label="Önceki sayfa"
                [disabled]="currentPage === 1" (click)="ChangePage(currentPage - 1)">
                <i class="bi bi-chevron-left" aria-hidden="true"></i>
              </button>
              <ng-container *ngIf="pageNumbers[0] > 1">
                <button type="button" class="pagination-button" aria-label="1. sayfa" (click)="ChangePage(1)">1</button>
                <span *ngIf="pageNumbers[0] > 2" class="pagination-dots" aria-hidden="true">…</span>
              </ng-container>
              <button *ngFor="let page of pageNumbers" type="button" class="pagination-button"
                [class.active]="currentPage === page" [attr.aria-current]="currentPage === page ? 'page' : null"
                [attr.aria-label]="page + '. sayfa'" (click)="ChangePage(page)">{{ page }}</button>
              <ng-container *ngIf="pageNumbers[pageNumbers.length - 1] < totalPages">
                <span *ngIf="pageNumbers[pageNumbers.length - 1] < totalPages - 1" class="pagination-dots" aria-hidden="true">…</span>
                <button type="button" class="pagination-button" [attr.aria-label]="totalPages + '. sayfa'"
                  (click)="ChangePage(totalPages)">{{ totalPages }}</button>
              </ng-container>
              <button type="button" class="pagination-button" aria-label="Sonraki sayfa"
                [disabled]="currentPage === totalPages" (click)="ChangePage(currentPage + 1)">
                <i class="bi bi-chevron-right" aria-hidden="true"></i>
              </button>
            </nav>
          </div>
        </div>
      </div>
    </section>
  </ng-container>
</main>

<!-- İki bölüm de aynı modele ve aynı kart şablonuna dayanır. -->
<ng-template #applicationCard let-application let-featured="featured">
  <article class="application-card" [class.featured-card]="featured">
    <div class="application-card-header">
      <div class="application-icon" [ngClass]="application.iconClass">
        <img *ngIf="HasImage(application); else fallbackIcon" [src]="application.imageSrc"
          [alt]="application.name + ' logosu'" loading="lazy" decoding="async" (error)="OnImageError(application)">
        <ng-template #fallbackIcon>
          <i class="bi" [ngClass]="application.icon || 'bi-app-indicator'" aria-hidden="true"></i>
        </ng-template>
      </div>
      <div class="application-heading">
        <h3><button type="button" class="application-title" (click)="OpenApplication(application)"
          [disabled]="!application.id">{{ application.name }}</button></h3>
        <p class="application-type">{{ application.type }}</p>
      </div>
    </div>
    <p class="application-description">{{ application.description }}</p>
    <div class="application-tags" aria-label="Uygulama etiketleri">
      <span *ngFor="let tag of application.tags" class="application-tag">{{ FormatTag(tag) }}</span>
    </div>
    <div class="application-card-footer">
      <div class="application-rating" [attr.aria-label]="application.rating > 0 ? application.rating + ' puan, ' + application.ratingCount + ' değerlendirme' : 'Henüz değerlendirme yok'">
        <i class="bi bi-star-fill" aria-hidden="true"></i>
        <ng-container *ngIf="application.rating > 0; else noRating">
          <strong>{{ application.rating | number:'1.1-1' }}</strong>
          <span>({{ application.ratingCount }})</span>
        </ng-container>
        <ng-template #noRating><span>Henüz puan yok</span></ng-template>
      </div>
      <button type="button" class="application-detail" [disabled]="!application.id"
        [attr.aria-label]="application.name + ' uygulamasını incele'" (click)="OpenApplication(application)">
        İncele <i class="bi bi-arrow-right" aria-hidden="true"></i>
      </button>
    </div>
  </article>
</ng-template>

<app-dashboard-error
  [errorMessage]="dashboardErrorMessage"
  homeUrl="/"
  (loginRequested)="GoToLogin()">
</app-dashboard-error>
